export { default } from "./Column";



// WEBPACK FOOTER //
// ./src/design-system/layout/Column/index.jsx